<script>
export default {
  computed: {
    pageIndex () {
      const index = this.$route.query.p - 0
      return Number.isInteger(index) ? index : 1
    },
    pageIndexMax () {
      return Math.ceil(this.newsList.length / 10)
    },
    prev () {
      return this.pageIndex - 1 || false
    },
    next () {
      return this.pageIndex < this.pageIndexMax ? this.pageIndex + 1 : false
    },
    newsList () {
      return this.docs.news
    },
    list () {
      return this.newsList.filter((news, index) => {
        return (this.pageIndex - 1) * 10 <= index && index < this.pageIndex * 10
      })
    }
  }
}
</script>

<template>
  <div class="gp-news-list transition-item">
    <div class="news-list-container">
      <transition name="slide-in">
        <ul class="news-list" :key="pageIndex">
          <li
            class="news"
            v-for="news in list"
            :key="news.id"
          >
            <router-link :to="{name: 'news-article', params: {'newsId': news.id}}">
              <div class="news-inner">
                <div class="image-wrapper level is-mobile">
                  <figure
                    class="image"
                    :style="'background-image: url(' + news.image + ')'"
                  ></figure>
                </div>
                <div class="content is-size-4 is-size-6-mobile">
                  <p class="has-text-weight-bold">{{ news.date }}</p>
                  <p class="title has-text-weight-bold">{{ news.title }}</p>
                  <p class="is-size-5 is-hidden-mobile">{{ news.description }}</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </transition>
    </div>
    <nav>
      <div class="level-center is-mobile is-family-oswald has-text-weight-bold is-size-2">
        <div :class="{disable: !prev}">
          <router-link :to="{query: {p: prev}}">
            <span :class="{link: prev}">PREV</span>
          </router-link>
        </div>
        <ul class="level is-mobile">
          <li
            v-for="p in pageIndexMax"
            :key="p"
            :class="{current: p === pageIndex}"
          >
            <router-link :to="{query: {p: p}}">
              <span class="link">{{ p }}</span>
            </router-link>
          </li>
        </ul>
        <div :class="{disable: !next}">
          <router-link :to="{query: {p: next}}">
            <span :class="{link: next}">NEXT</span>
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.gp-news-list {
  .news-list-container {
    position: relative;
  }
  ul.news-list {
    .news {
      .content {
        background-color: $white-transparent;
        width: 100%;
      }

      @include is-mobile {
        min-height: 4.5rem;
        margin: 0 1rem 1rem;
        figure {
          min-width: 9rem;
          height: 4.5rem;
        }
        .content {
          padding: .5rem;
          min-height: 4.5rem;
        }
      }

      @include is-not-mobile {
        margin: 0 auto 1rem;
        figure {
          width: 300px;
          min-width: 300px;
          height: 150px;
        }
        .content {
          min-height: 150px;
          padding: 1rem 1.5rem;
          .title {
            margin-bottom: 1rem;
          }
        }
      }
    }
  }
  nav {
    margin-top: 3rem;
    div {
      @include is-not-mobile {
        margin: 0 1rem;
      }
    }
    ul li {
      margin: 0 .5rem;
      span {
        padding: 0 .625rem;
      }
    }
    .current .link,
    .link:hover {
      color: $orange;
    }
  }
}

.news-inner {
  display: flex;
  align-items: stretch;
}

.image-wrapper {
  background-color: $black;
}
</style>



// WEBPACK FOOTER //
// src/components/page/news/news-list.vue